export * from './signal.utils';
export * from './comparer.util';
export * as Signals from './signals';
export * from './signals';
import DateUtils from './date.utils';
export {DateUtils};
export * from './promise.util';
export * from './files';
export * from './object';
export * from './matchers';
export * from './types';

export {listenForKeyboardCode} from './keyboard-code-capture';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function debounce<T extends (...args: any[]) => void>(func: T, wait: number): T;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function debounce<T extends (...args: any[]) => any>(func: T, wait: number): (...args: Parameters<T>) => Promise<ReturnType<T>>;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function debounce<T extends ((...args: any[]) => void)|((...args: any[]) => any)>(func: T, wait: number): (...args: Parameters<T>) => T|Promise<ReturnType<T>> {
  let timeout: number|undefined;
  let promise: PromiseWithResolvers<ReturnType<T>> = Promise.withResolvers<ReturnType<T>>();
  // @ts-expect-error: ts can't infer the return type of the function based on the overloads
  return function (this: unknown, ...args: unknown[]) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      if (!timeout) {
        return;
      }
      try {
        const result = func.apply(context, args);
        if (typeof result !== 'undefined' && result instanceof Promise) {
          result.then(promise.resolve, promise.reject);
        } else {
          promise.resolve(result);
        }
      } catch (e) {
        promise.reject(e);
      } finally {
        promise = Promise.withResolvers<ReturnType<T>>();
        timeout = undefined;
      }
    }, wait) as unknown as number;
    return promise.promise;
  } as T;
}
//
// export function debounce(func: Function, wait: number) {
//   let timeout: any;
//   return function (this: any, ...args: any[]) {
//     const context = this;
//     clearTimeout(timeout);
//     timeout = setTimeout(() => func.apply(context, args), wait);
//   };
// }
